/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { call, put, take, takeEvery, select } from 'redux-saga/effects';
import { requestApi, parseResponse } from 'src/providers/http-api.provider';
import { GET_COMPANIES } from 'src/types/companies-action.type';
import { getPrettierMessage } from 'src/utils/global';
import { getCompaniesError, getCompaniesSuccess } from '../actions/companies.action';
import { ApiPlatformUrl } from 'src/utils/config';
import { AppMessages } from 'src/constants/messages.constant';
import { ApiErrorsCodes } from 'src/constants/endpoints.constant';

function* onGetCompanies():any {
  let errorMessage = '';
  let payload = {};
  try {
    const accessToken = yield select(state => state.auth?.accessToken);
    const licenseId = yield select(state => state.settings?.currentLicense?.licenseID);
    const applicationId = yield select(state => state.settings?.currentApplication?.serviceID);
    if (accessToken ) {
      const endpoint = `${ApiPlatformUrl}/Companies?LicenseId=${licenseId}&ServiceId=${applicationId}`;
      let response = yield call(requestApi, {
        endpoint,
        method: 'GET',
        headers: {
          Authorization: accessToken,
        },
        useParseResponse: false,
      });
      if (response?.ok) {
        let companies = yield call(parseResponse, response);
        if (companies.length > 0) {
          payload = {
            data: companies,
            isEmptyData: false,
          }
          yield put(getCompaniesSuccess(payload));
        } else {
          payload = {
            data: [],
            isEmptyData: true,
          }
          yield put(getCompaniesSuccess(payload));
        }
      } else {
        if (response?.status === ApiErrorsCodes.NOT_FOUND) {
          payload = {
            data: [],
            isEmptyData: true,
          }
          yield put(getCompaniesSuccess(payload));
        } else {
          const apiError = yield call(parseResponse, response);
          let apiErrorMessage = getPrettierMessage(apiError?.Message);
          if (apiErrorMessage) {
            errorMessage =`${apiErrorMessage} ${AppMessages.REINTENT_LABEL}`;
          }
          throw new Error(errorMessage);
        }
      }
    } else {
      throw new Error("accessToken empty");
    }
  } catch (err) {
    console.log("Fail onGetCompanies: ", err);
    yield put(getCompaniesError(err || AppMessages.ERROR_GENERIC));
  }
}

export function* watchOnGetCompanies() {
  yield takeEvery(GET_COMPANIES, onGetCompanies);
}
